import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

type CloneTarget = components["schemas"]["CloneTarget"];

interface CloneToMarketplacesInput {
  id: string;
  targets: CloneTarget[];
}

/** POST /v1/promotions/{id}/clone-to-marketplaces — one draft per target, linked group. */
export function useCloneToMarketplaces() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, targets }: CloneToMarketplacesInput) => {
      const { data, error } = await apiClient.POST("/v1/promotions/{id}/clone-to-marketplaces", {
        params: { path: { id } },
        body: { targets },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
